import React, { useEffect, useState } from "react";
import CustomSelect from "../common/Select";
import axios from "../../axios/axiosconf";



function SelectorCiudad({ value, onChange, placeholder = "Ciudad de Residencia", cuestionarioPacienteId, cuestionarioToken, error }) {
  const [ciudades, setCiudades] = useState([]);
  const [cargando, setCargando] = useState(true);

  const esCuestionarioPublico = Boolean(cuestionarioPacienteId && cuestionarioToken);

  useEffect(() => {
    const params = esCuestionarioPublico
      ? { paciente_id: cuestionarioPacienteId, token: cuestionarioToken }
      : {};
    const url = esCuestionarioPublico ? "/ciudad-cuestionario" : "/ciudad";

    axios.get(url, { params })
      .then((res) => {
        console.log("Datos de ciudades recibidos:", res.data); // Para debug
        const opciones = res.data.map((c) => ({
          value: c.id,
          label: c.nombre_ciudad
        }));
        setCiudades(opciones);
      })
      .catch((err) => {
        console.error("Error cargando ciudades:", err);
        setCargando(false);
      })
      .finally(() => setCargando(false));
  }, [esCuestionarioPublico, cuestionarioPacienteId, cuestionarioToken]);

  // Función para encontrar el valor seleccionado
  const valorSeleccionado = ciudades.find(c => c.value == value) || null;

  return (
    <CustomSelect
      isLoading={cargando}
      options={ciudades}
      value={valorSeleccionado}
      onChange={onChange}
      placeholder={placeholder}
      isClearable
      error={error}
    />
  );
}

export default SelectorCiudad;